let gridLineLinkSpacing = 24;

function circleY(el) {
  let y = el.offsetTop + el.offsetHeight / 2;
  let node = el.offsetParent;
  while (node && node.id !== 'scaler') {
    y += node.offsetTop;
    node = node.offsetParent;
  }
  return y;
}

function lineColor(outputType) {
  if (outputType == "operator") {
    return "#B23440";
  }
  if (outputType == "logic") {
    return "#4A7A99";
  }
  if (outputType == "card") {
    return "#25846B";
  }
  if (outputType == "detour") {
    return "#655A9D";
  }
  return "#24C3D5";
}

function linkOffset(nodeType) {
  if (nodeType == "card" || nodeType == "logic") {
    return 36;
  }

  return 13;
}

export function drawLines(storyData, edit) {
  if (!storyData.data.stories) {
    return;
  }

  let xmlns = "http://www.w3.org/2000/svg";
  let svgElem = document.createElementNS(xmlns, "svg");
  svgElem.id = "svglines";
  let lines = [];
  let count = 0;
  let lineindex = 0;
  let thisCard;
  let thatCard;
  let cardWidth = 120;
  let maxRight = 800;
  let maxBottom = 600;

  Object.entries(storyData.data.stories[edit.currentStorylet].cards).forEach(
    ([key, card]) => {
      lines.push("");

      maxRight = Math.max(maxRight, card.editor.left + 118);
      maxBottom = Math.max(maxBottom, card.editor.top + 120);

      thisCard = storyData.data.stories[edit.currentStorylet].cards[key];

      if (!thisCard.links) {
        return;
      }

      Object.entries(thisCard.links).forEach(([linkKey, link]) => {
        if (storyData.data.stories[edit.currentStorylet].cards[link.target]) {
          thatCard =
            storyData.data.stories[edit.currentStorylet].cards[link.target];

          // Calculate start and end points
          const x1 = thisCard.editor.left + cardWidth;
          const circleEl = document.getElementById('link_' + key + '_' + linkKey);
          const y1 = (circleEl
            ? circleY(circleEl)
            : thisCard.editor.top + linkOffset(thisCard.nodeType) + lineindex * gridLineLinkSpacing) + 2;
          const x2 = thatCard.editor.left;
          const y2 = thatCard.editor.top + 12;

          // Calculate control points for the cubic Bézier curve
          // Control points are offset horizontally to create a smooth curve
          const controlX1 = x1 + 100; // Adjust the horizontal offset for the curve
          const controlY1 = y1;
          const controlX2 = x2 - 100; // Adjust the horizontal offset for the curve
          const controlY2 = y2;

          const distance = Math.sqrt(
            Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2)
          );

          const drawLine = distance < 120;

          // Create the path element for the curved line
          const path = document.createElementNS(xmlns, "path");

          if (!drawLine) {
            path.setAttributeNS(
              null,
              "d",
              `M ${x1},${y1} C ${controlX1},${controlY1} ${controlX2},${controlY2} ${x2},${y2}`
            );
            path.setAttributeNS(null, "stroke", lineColor(thisCard.nodeType));
            path.setAttributeNS(null, "stroke-width", 2);
            path.setAttributeNS(null, "fill", "none"); // Ensure the path is not filled
          } else {
            path.setAttribute("d", `M ${x1} ${y1} L ${x2} ${y2}`);
            path.setAttribute("stroke", lineColor(thisCard.nodeType));
            path.setAttribute("stroke-width", "2");
            path.setAttribute("fill", "none");
          }

          if (thisCard.nodeType != "end" && key != link.target) {
            svgElem.appendChild(path);
          }

          // Calculate the midpoint of the curve for the arrowhead

          const t = 0.5; // Midpoint parameter for the curve
          let midX, midY, angle;

          if (!drawLine) {
            midX =
              Math.pow(1 - t, 3) * x1 +
              3 * Math.pow(1 - t, 2) * t * controlX1 +
              3 * (1 - t) * Math.pow(t, 2) * controlX2 +
              Math.pow(t, 3) * x2;
            midY =
              Math.pow(1 - t, 3) * y1 +
              3 * Math.pow(1 - t, 2) * t * controlY1 +
              3 * (1 - t) * Math.pow(t, 2) * controlY2 +
              Math.pow(t, 3) * y2;

            // Calculate the tangent angle at the midpoint for the arrowhead orientation
            const dx =
              3 * Math.pow(1 - t, 2) * (controlX1 - x1) +
              6 * (1 - t) * t * (controlX2 - controlX1) +
              3 * Math.pow(t, 2) * (x2 - controlX2);
            const dy =
              3 * Math.pow(1 - t, 2) * (controlY1 - y1) +
              6 * (1 - t) * t * (controlY2 - controlY1) +
              3 * Math.pow(t, 2) * (y2 - controlY2);
            angle = Math.atan2(dy, dx);
          } else {
            midX = (x1 + x2) / 2;
            midY = (y1 + y2) / 2;

            angle = Math.atan2(y2 - y1, x2 - x1);
          }

          // Create an arrowhead at the midpoint
          const arrowhead = document.createElementNS(xmlns, "polygon");
          arrowhead.setAttributeNS(null, "fill", lineColor(thisCard.nodeType));

          // Arrowhead points (adjust these based on your needs)
          const arrowSize = 10; // size of the arrowhead
          const arrowX1 = midX - arrowSize * Math.cos(angle + Math.PI / 6);
          const arrowY1 = midY - arrowSize * Math.sin(angle + Math.PI / 6);
          const arrowX2 = midX - arrowSize * Math.cos(angle - Math.PI / 6);
          const arrowY2 = midY - arrowSize * Math.sin(angle - Math.PI / 6);

          // Set the points for the arrowhead (triangle)
          arrowhead.setAttributeNS(
            null,
            "points",
            `${midX},${midY} ${arrowX1},${arrowY1} ${arrowX2},${arrowY2}`
          );

          if (thisCard.nodeType != "end" && key != link.target) {
            svgElem.appendChild(arrowhead);
          }
        }
        lineindex++;
      });

      lineindex = 0;
      count++;
    }
  );

  const canvasW = maxRight + 400;
  const canvasH = maxBottom + 300;
  const scale = edit.cardsScale ?? 1;

  svgElem.setAttribute("width", canvasW);
  svgElem.setAttribute("height", canvasH);

  const scaler = document.getElementById("scaler");
  if (scaler) {
    scaler.style.width = canvasW + "px";
    scaler.style.height = canvasH + "px";
    scaler.style.transform = `scale(${scale})`;
  }

  const scalerOuter = document.getElementById("scaler-outer");
  if (scalerOuter) {
    scalerOuter.style.width = Math.round(canvasW * scale) + "px";
    scalerOuter.style.height = Math.round(canvasH * scale) + "px";
  }

  let svgContainer = document.getElementById("linesSVG");
  if (svgContainer) {
    svgContainer.replaceChild(svgElem, svgContainer.firstChild);
  }
}
